"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/text/text");
/** level(1–5)별 의미 단계(h1–h5)와 페어링하는 타입 스케일 크기 */
const LEVEL_SIZE = {
    1: '32',
    2: '24',
    3: '18',
    4: '14',
    5: '12',
};
/**
 * <mm-heading>
 * 화면 안에서 주요 콘텐츠 묶음을 구분하는 제목입니다.
 * level(1–5)로 의미 단계(h1–h5)와 크기를 함께 지정하며, 기본값은 2입니다.
 * level 5는 그룹 라벨용으로 보조 색을 갖습니다.
 */
let Heading = class Heading extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.level = 2;
    }
    render() {
        const size = LEVEL_SIZE[this.level] ?? '24';
        return (0, lit_1.html) `
      <mm-text as="h${this.level}" size=${size} weight="bold">
        <slot></slot>
      </mm-text>
    `;
    }
};
Heading.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    /* 가장 낮은 단계는 그룹 라벨로 쓰여 본문보다 한 단계 물러난다. */
    :host([level='5']) {
      color: var(--foreground-subtle-color);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Number, reflect: true })
], Heading.prototype, "level", void 0);
Heading = __decorate([
    (0, decorators_js_1.customElement)('mm-heading')
], Heading);
exports.Heading = Heading;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVhZGluZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImhlYWRpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCx5Q0FBc0M7QUFLdEMsZ0RBQWdEO0FBQ2hELE1BQU0sVUFBVSxHQUFtQztJQUNqRCxDQUFDLEVBQUUsSUFBSTtJQUNQLENBQUMsRUFBRSxJQUFJO0lBQ1AsQ0FBQyxFQUFFLElBQUk7SUFDUCxDQUFDLEVBQUUsSUFBSTtJQUNQLENBQUMsRUFBRSxJQUFJO0NBQ1IsQ0FBQTtBQUVEOzs7OztHQUtHO0FBRUksSUFBTSxPQUFPLEdBQWIsTUFBTSxPQUFRLFNBQVEsZ0JBQVU7SUFBaEM7O1FBV3NDLFVBQUssR0FBaUIsQ0FBQyxDQUFBO0lBVXBFLENBQUM7SUFSQyxNQUFNO1FBQ0osTUFBTSxJQUFJLEdBQUcsVUFBVSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxJQUFJLENBQUE7UUFDM0MsT0FBTyxJQUFBLFVBQUksRUFBQTtzQkFDTyxJQUFJLENBQUMsS0FBSyxVQUFVLElBQUk7OztLQUd6QyxDQUFBO0lBQ0gsQ0FBQzs7QUFuQk0sY0FBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7R0FTbEIsQ0FBQTtBQUMwQztJQUExQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQztzQ0FBd0I7QUFYdkQsT0FBTztJQURuQixJQUFBLDZCQUFhLEVBQUMsWUFBWSxDQUFDO0dBQ2YsT0FBTyxDQXFCbkI7QUFyQlksMEJBQU8ifQ==